import { render, staticRenderFns } from "./ClientesCanal.vue?vue&type=template&id=8d44897c&scoped=true&"
import script from "./ClientesCanal.vue?vue&type=script&lang=ts&"
export * from "./ClientesCanal.vue?vue&type=script&lang=ts&"
import style0 from "./ClientesCanal.vue?vue&type=style&index=0&id=8d44897c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d44897c",
  null
  
)

export default component.exports